import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './redux';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from './utils/toast';
import { MuiThemeProvider } from '@material-ui/core';
import { yamahaTheme } from './base/YamahaTheme';

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider maxSnack={3}>
      <SnackbarUtilsConfigurator />
      <MuiThemeProvider theme={yamahaTheme}>
        <App />
      </MuiThemeProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
